module.exports = __webpack_public_path__ + "static/media/112.028f0d91.mp3";